<img
  class="error-screen__image"
  src="/assets/images/emision-error.png"
  alt="Icono error"
/>
<sc-title class="error-screen__title" [content]="title" type="h2"></sc-title>
<p class="error-screen__message" [innerHTML]="message"></p>
<div class="error-screen__buttons">
  <sc-button
    id="error-screen-button"
    class="error-screen__button"
    [loading]="buttonLoading"
    (onClick)="handleButtonClicked()"
  >
    {{ buttonLabel }}
  </sc-button>
  <sc-button
    *ngIf="secondaryButtonLabel"
    id="error-screen-secondary-button"
    class="error-screen__button"
    type="secondary"
    [loading]="secondaryButtonLoading"
    (onClick)="handleSecondaryButtonClicked()"
  >
    {{ secondaryButtonLabel }}
  </sc-button>
</div>
